import { ApplicationQuestion, FieldType } from '@bybeam/platform-types';
import { makeEduConfig } from './baseConfig.js';

const CONFIG = makeEduConfig();

const newQuestions: ApplicationQuestion[] = [
  {
    key: 'receivingProgramBenefits',
    copy: { title: 'Are you currently receiving any of the following?' },
    fields: [
      {
        type: FieldType.CheckboxGroup,
        key: 'receivingProgramBenefits',
        options: [
          { label: 'Pell Grant', value: 'pell-grant' },
          { label: 'Supplemental Nutrition Assistance Program (SNAP)', value: 'snap' },
          { label: 'TANF/OWF- Cash Assistance', value: 'tanf-owf' },
          { label: 'WIC', value: 'wic' },
          { label: 'None of the above', value: 'none' },
        ],
      },
    ],
  },
  {
    key: 'applicantStatuses',
    copy: { title: 'Are you a:' },
    fields: [
      {
        type: FieldType.CheckboxGroup,
        key: 'applicantStatus',
        options: [
          { label: 'Veteran', value: 'veteran' },
          { label: 'Active Duty Military Personnel', value: 'active-duty-military-personnel' },
          { label: 'Reservist', value: 'reservist' },
          { label: 'National Guard member', value: 'national-guard-member' },
          {
            label: 'Spouse, Child, or Legal dependent of any of the above',
            value: 'legal-dependent',
          },
          { label: 'None of the above', value: 'none' },
        ],
      },
    ],
  },
];

const personalInfoSection = CONFIG.sections.find(({ key }) => key === 'personalInfo');
const personalInfoQuestionGroup = personalInfoSection.questionGroups.find(
  ({ key }) => key === 'personalInfo',
);

personalInfoQuestionGroup.questions.push(...newQuestions);

export default CONFIG;
